import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { SYSTEM_ADMIN_PATH } from '../../../../constants';

import { fetchDesignationElementsRequest } from './actions';
import { getDesignationElementById } from './reducer';

const DesignationElements = React.lazy(() => import('./index'));
const CreateDesignationElement = React.lazy(() => import('./DesignationElement/Create'));
const DesignationElementDetails = React.lazy(() => import('./DesignationElement/Detail'));

const GetDesignationElementDetails = ({ match }) => {
     const dispatch = useDispatch();
     const designationElements = useSelector((state) => state.admin.designationElements);

     const fetchDesignationElements = () => {
          if (!designationElements.length) {
               dispatch(fetchDesignationElementsRequest());
          }
     };

     let designName = '';

     if (designationElements.length) {
          designName = getDesignationElementById(designationElements, match.params.id)?.name ?? '';
     }

     useEffect(fetchDesignationElements, [designationElements]); // eslint-disable-line react-hooks/exhaustive-deps

     return <span>{designName}</span>;
};

const routes = {
     path: SYSTEM_ADMIN_PATH.DESIGNATION_ELEMENTS,
     breadcrumb: 'Designation Elements',
     element: <Outlet />,
     children: [
          { index: true, element: <DesignationElements /> },
          { path: SYSTEM_ADMIN_PATH.DESIGNATION_ELEMENTS_CREATE, breadcrumb: 'Create', element: <CreateDesignationElement /> },
          { path: SYSTEM_ADMIN_PATH.DESIGNATION_ELEMENTS_DETAIL, breadcrumb: GetDesignationElementDetails, element: <DesignationElementDetails /> },
     ],
};

export default routes;
